import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { SubscriptionPaymentsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const getSubscriptionPayment = (subscriptionPaymentId): any => action(types.GET_SUBSCRIPTION_PAYMENT_REQUESTED, subscriptionPaymentId);

export const updateSubscriptionPayment = (
  data,
  paymentEventDashboardId = undefined,
  paymentEventId = undefined,
  callbackFunction = undefined,
): any => action(types.UPDATE_SUBSCRIPTION_PAYMENT_REQUESTED, {
  data,
  paymentEventDashboardId,
  paymentEventId,
  callbackFunction,
});

export const getAllSubscriptionPayments = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_SUBSCRIPTION_PAYMENTS_REQUESTED, { pagination, compile });

export const selectSubscriptionPayment = (subscriptionPaymentId): any => action(types.SELECT_SUBSCRIPTION_PAYMENT_REQUESTED, {
  currentSubscriptionPaymentId: subscriptionPaymentId,
});
export const clearSubscriptionPayments = (): any => action(types.CLEAR_SUBSCRIPTION_PAYMENTS);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  getSubscriptionPaymentPending: (): any => action(types.GET_SUBSCRIPTION_PAYMENT_PENDING, {}),
  getSubscriptionPaymentSuccess: (response): any => action(types.GET_SUBSCRIPTION_PAYMENT_SUCCESS, {
    subscriptionPaymentsById: response.entities.subscriptionPayments,
    currentSubscriptionPaymentId: response.result,
  }),
  getSubscriptionPaymentFailed: (error): any => action(types.GET_SUBSCRIPTION_PAYMENT_FAIL, { backendErrors: error }),
  getAllSubscriptionPaymentsPending: (pagination): any => action(types.GET_ALL_SUBSCRIPTION_PAYMENTS_PENDING, { pagination }),
  getAllSubscriptionPaymentsSuccess: (response, meta): any => action(types.GET_ALL_SUBSCRIPTION_PAYMENTS_SUCCESS, {
    subscriptionPaymentsById: response.entities.subscriptionPayments,
    subscriptionPaymentIds: response.result,
    meta,
  }),
  getAllSubscriptionPaymentsFailed: (error): any => action(types.GET_ALL_SUBSCRIPTION_PAYMENTS_FAIL, { backendErrors: error }),
  updateSubscriptionPaymentPending: (payload): any => action(types.UPDATE_SUBSCRIPTION_PAYMENT_PENDING, payload),
  updateSubscriptionPaymentSuccess: (response): any => action(types.UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS, {
    paymentsById: response.entities.payments,
    currentPaymentId: response.result,
  }),
  updateSubscriptionPaymentFailed: (error): any => action(types.UPDATE_SUBSCRIPTION_PAYMENT_FAIL, { backendErrors: error }),
};

export default {
  getSubscriptionPayment,
  updateSubscriptionPayment,
  getAllSubscriptionPayments,
  selectSubscriptionPayment,
  clearSubscriptionPayments,
};
